// extracted by mini-css-extract-plugin
export default {"overlay":"alert_overlay__R+dW3","alert":"alert_alert__eXlWM","title":"alert_title__e8t-e","message":"alert_message__yx2q+","closeButton":"alert_closeButton__fCD6v"};